<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
                <el-form :inline="true" >
                    <el-form-item>
                        <el-select size="small" v-model="searcheModel.time_type" style="width:100px;">
                            <el-option label="申请时间" value="1"></el-option>
                            <el-option label="绑定时间" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                                size="small"
                                type="daterange"
                                unlink-panels
                                value-format="yyyy-MM-dd"
                                v-model="searcheModel.apply_time"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="产品类型">
                        <Product ref="product" :product_id="searcheModel.product_id"
                        @change="productChange"></Product>
                    </el-form-item>
                    <el-form-item label="来源" prop="source">
                        <ChannelCascader ref="ChannelCascader" :channel="channel" @change="channelHandleChange"></ChannelCascader>
                    </el-form-item>
                    <el-form-item label="所属部门">
                        <UserCascader v-model="searcheModel.branch_id" ref="branch" :isBusiness="true" @change="changeBranch"></UserCascader>
                    </el-form-item>
                    <el-form-item label="业务员">
                        <UserSelect :name="searcheModel.username" ref="user" v-model="searcheModel.user_id"
                        @change="salesmanHandleChange"></UserSelect>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submit" >搜索
                        </el-button>
                    </el-form-item>
                </el-form>
        </div>
        <div class="main-bd mg20 pro-visible">
            <label class="item-title">申请端口分析</label>
            <div class="flex-container">
                <!-- 左侧 -->
                <div class="left" style="text-align: center;">
                    <div style="width: 100%;">
                        <el-row :gutter="50">
                            <el-col :span="14"><div class="grid-content bg-purple">申请日期</div></el-col>
                            <el-col :span="10"><div class="grid-content bg-purple">申请总量</div></el-col>
                        </el-row>
                        <el-row :gutter="50">
                            <el-col :span="14"><div class="grid-content bg-purple">{{searcheModel.apply_time?_.join(searcheModel.apply_time,"至"):'所有'}}</div></el-col>
                            <el-col :span="10"><div class="grid-content bg-purple">{{total_origin_num}}</div></el-col>
                        </el-row>
                    </div>
                </div>

                <!-- 右侧 -->
                <div class="right">
                    <!-- 上方 -->
                    <div class="right-top">
                        <label class="item-title">申请网站</label>
                        <div style="padding-left: 15px;">
                            <el-row :gutter="10">
                                <el-col  v-for="(origin, origin_index) in origin_count_data" :key="origin_index" :label="origin.name" :span="Math.floor(24 / origin_count_data.length)">
                                    <div class="grid-content">
                                        <div class="ellipsis">{{ origin.name }}</div>
                                        <div class="ellipsis">{{ origin.value }}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>

                    <!-- 下方 -->
                    <div class="right-bottom">
                        <label class="item-title">申请产品</label>
                        <div style="padding-left: 15px;">
                            <el-row :gutter="10">
                                <el-col  v-for="(product, product_index) in product_count_data" :key="product_index" :label="product.name" :span="Math.floor(24 / product_count_data.length)">
                                    <div class="grid-content">
                                        <div class="ellipsis">{{ product.name }}</div>
                                        <div class="ellipsis">{{ product.value }}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <!-- 下方 -->
                    <div class="right-bottom">
                        <label class="item-title">线索真实性</label>
                        <div style="padding-left: 15px;">
                            <el-row :gutter="10">
                                <el-col  v-for="(item, index) in status_count_data" :key="index" :label="item.name" :span="item.span">
                                    <div class="grid-content">
                                        <div class="ellipsis">
                                            {{ item.name }}
                                            <span>
                                                <el-tooltip v-if="item.content" class="item" effect="dark" :content="item.content" placement="top">
                                                    <i class="el-icon-info"></i>
                                                </el-tooltip>
                                            </span>
                                        </div>
                                        <div class="ellipsis">{{ item.value }}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-bd mg20 pro-visible">
            <label class="item-title">线索来源分析</label><ExportFile url="/api/export/channel-bar" :params="searcheModel" filename="渠道申请分析数据表">导出</ExportFile>
            <BarChart :params="searcheModel" :key="bar_chart_key"></BarChart>
        </div>
        <div class="main-bd mg20 pro-visible">
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-card>
                        <label class="item-title">线索转化分析</label>
                        <FunnelChart :params="searcheModel" :key="funnel_chart_key"></FunnelChart>
                    </el-card>
                </el-col>
                <el-col :span="16">
                    <el-card>
                        <label class="item-title">线索真实性分析</label>
                        <SimpleChart :params="searcheModel" :key="simple_chart_key"></SimpleChart>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <label class="item-title">绑定线索转化分析</label>
            <el-table 
            v-if="!loading"
            :data="traces_list"
            border
            height="600"
            :summary-method="getSummaries"
            show-summary
            :header-cell-style="{background: '#f3faff'}"
            >
                <el-table-column prop="user_name" label="业务员"></el-table-column>
                <el-table-column prop="not_bind_customer_num" label="未关联客户线索数">
                    <template slot-scope="scope">
                        <!-- 单元格内容 -->
                        <el-button type="text" @click="handleView(scope.row, 0)">
                        {{ scope.row.not_bind_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                  <el-table-column prop="bind_customer_num" label="关联客户线索数">
                    <template slot-scope="scope">
                        <!-- 单元格内容 -->
                        <el-button type="text" @click="handleView(scope.row, 1)">
                        {{ scope.row.bind_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="sales_num" label="已绑线索数"></el-table-column> -->
                <el-table-column prop="customer_num" label="关联客户数">
                    <template slot-scope="scope">
                        <!-- 单元格内容 -->
                        <el-button type="text" @click="tableCustomerDialog(scope.row)">
                        {{ scope.row.customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="try_out_order_num" label="试用订单数">
                    <template slot-scope="scope">
                        <!-- 单元格内容 -->
                        <el-button type="text" @click="tableOrderDialog(scope.row, 1)">
                        {{ scope.row.try_out_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="formal_order_num" label="正式订单数">
                    <template slot-scope="scope">
                        <!-- 单元格内容 -->
                        <el-button type="text" @click="tableOrderDialog(scope.row, 4)">
                        {{ scope.row.formal_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="pfm_amount" label="新增业绩"></el-table-column>
                <el-table-column prop="renew_amount" label="续费业绩"></el-table-column>
                <!-- <el-table-column prop="sum_total_amount" label="销售总额"></el-table-column> -->
            </el-table>
            <CustomerListDialog :params="params" v-if="dialogTableCustomerVisible" :key="dialog_table_customer_key"></CustomerListDialog>
            <OrderListDialog :params="params" v-if="dialogTableOrderVisible" :key="dialog_table_order_key"></OrderListDialog>
            <!-- 新增：周期订单对话框 -->
                    <CycleOrderListDialog
                        :params="cycleParams"
                        :title="cycleDialogTitle"
                        v-if="dialogCycleOrderVisible"
                        :key="dialog_cycle_order_key">
                    </CycleOrderListDialog>
        </div>
        <!-- 只有申请时间类型时才显示 -->
        <CycleCustomerListDialog
            :params="cycleCustomerParams"
            v-if="dialogCycleCustomerVisible"
            :key="dialog_cycle_customer_key"
            @close="dialogCycleCustomerVisible = false">
        </CycleCustomerListDialog>
        <div class="main-bd mg20 pro-visible" v-if="searcheModel.time_type === '1'" v-loading="cycleLoading">
            <div style="margin-bottom: 15px;">
                <label class="item-title">线索指定周期转化分析（含未绑线索）</label>
                <el-form :inline="true" style="display: inline-block; margin-left: 20px;">
                    <el-form-item label="转换日期">
                        <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            value-format="yyyy-MM-dd"
                            v-model="searcheModel.conversion_time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="handleConversionTimeChange">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="getCycleConversionlist(searcheModel)">
                            查询
                        </el-button>
                        <el-button size="small" @click="resetConversionTime">
                            重置
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>

            <el-table
                v-if="!cycleLoading"
                :data="cycle_traces_list"
                border
                height="600"
                :summary-method="getCycleSummaries"
                show-summary
                :header-cell-style="{background: '#f3faff'}"
            >
                <el-table-column prop="user_name" label="业务员"></el-table-column>
                <el-table-column prop="trial_customer_num" label="关联试用客户数">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleCycleCustomerView(scope.row, 'trial')">
                            {{ scope.row.trial_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
              <el-table-column prop="trial_order_num" label="关联试用订单数">
                  <template slot-scope="scope">
                      <el-button type="text" @click="tableCycleOrderDialog(scope.row, 'trial')">
                          {{ scope.row.trial_order_num }}
                      </el-button>
                  </template>
              </el-table-column>
                <el-table-column prop="effective_customer_num" label="有效试用客户数">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleCycleCustomerView(scope.row, 'effective')">
                            {{ scope.row.effective_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
              <el-table-column prop="effective_order_num" label="有效试用订单数">
                  <template slot="header" slot-scope="scope">
                      有效试用订单数
                      <el-tooltip class="item" effect="dark" content="线索关联试用订单后并有下载资料，要求科目数≥2，下载量≥50" placement="top">
                          <i class="el-icon-info"></i>
                      </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                      <el-button type="text" @click="tableCycleOrderDialog(scope.row, 'effective')">
                          {{ scope.row.effective_order_num }}
                      </el-button>
                  </template>
              </el-table-column>
                <el-table-column prop="success_customer_num" label="关联客户成交数">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleCycleCustomerView(scope.row, 'success')">
                            {{ scope.row.success_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="success_order_num" label="关联订单成交数">
                    <template slot-scope="scope">
                        <el-button type="text" @click="tableCycleOrderDialog(scope.row, 'success')">
                            {{ scope.row.success_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<style scoped>
.flex-container {
  display: flex;
  align-items: stretch; /* 垂直方向上对齐 */
}

.left {
  flex: 1; /* 左侧占据所有可用空间 */
  display: flex;
  justify-content: center; /* 水平方向上居中对齐 */
  align-items: center; /* 垂直方向上居中对齐 */
  border: 2px solid #ccc; /* 添加边框线 */
}

.right {
  flex: 3; /* 右侧占据左侧的两倍空间 */
  display: flex;
  flex-direction: column; /* 上下布局 */
}

.right-top, .right-bottom {
  flex: 1; /* 上下两个部分平分高度 */
  border: 2px solid #ccc; /* 添加边框线 */
}
.main-bd .el-row {
    padding: 10px 0;
}
.grid-content {
   text-align: center;
   margin-bottom: 10px;
}
.ellipsis {
    margin-bottom: 10px;
}
</style>
<script>
    import CycleOrderListDialog from "~/views/clue/dialog/CycleOrderListDialog.vue";
    import CycleCustomerListDialog from "~/views/clue/dialog/CycleCustomerListDialog.vue";
    import ClueService from "~/services/SaleClues";
    import ClueCount from "~/services/ClueCount";
    import BarChart from "~/views/clue/echarts/BarChart.vue";
    import FunnelChart from "~/views/clue/echarts/FunnelChart.vue";
    import SimpleChart from "~/views/clue/echarts/SimpleChart.vue";
    import CustomerListDialog from "~/views/clue/dialog/customerListDialog.vue";
    import OrderListDialog from "~/views/clue/dialog/orderListDialog.vue";
    import Product from "~/widgets/Product.vue";
    import ChannelCascader from "~/widgets/ChannelCascader.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    import echarts from 'echarts';
    import UserCascader from "~/widgets/UserCascader.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import Config from "~/config/params";
    export default {
        name: "analyze",
        components:{
            echarts,
            BarChart,
            FunnelChart,
            SimpleChart,
            Product,
            ChannelCascader,
            ExportFile,
            UserCascader,
            UserSelect,
            CustomerListDialog,
            OrderListDialog,
            CycleOrderListDialog, // 新增
            CycleCustomerListDialog, // 添加这一行
        },
        data(){
            return {
                list:[],
                h5_view:'h5',
                web_view:'web',
                mobileData:[],
                webData:[],
                total_origin_num: 0,
                origin_count_data:[],
                product_count_data:[],
                status_count_data:[],
                searcheModel:{
                    time_type: '1',
                    apply_time:Config.getDataTimes('this_week'),
                    product_id: '',
                    source: '',
                    branch_id: '',
                    user_id: '',
                    conversion_time: Config.getDataTimes('this_week'), // 默认与申请时间一致
                },
                orgOptions: {},
                BarChartShow: true,
                FunnelChartShow: true,
                SimpleChartShow: true,
                channel: {
                    pid: 0,
                    id: 0,
                },
                exportButtonLoading: false,
                traces_list: [],
                loading: false,
                bar_chart_key: 0,
                funnel_chart_key: 0,
                simple_chart_key: 0,
                dialogTableCustomerVisible: false,
                dialogTableOrderVisible: false,
                dialogCycleOrderVisible: false, // 新增
                params: {},
                cycleParams: {}, // 新增，用于周期订单
                cycleDialogTitle: '', // 新增，周期订单弹窗标题
                dialog_table_customer_key: 0,
                dialog_table_order_key: 0,
                dialog_cycle_order_key: 0, // 新增
                cycle_traces_list: [], // 新增：周期转化列表
                cycleLoading: false, // 新增：周期表格loading状态
                 dialogCycleCustomerVisible: false, // 周期客户弹框可见性
                cycleCustomerParams: {}, // 周期客户弹框参数
                dialog_cycle_customer_key: 0, // 周期客户弹框key
            }
        },
        watch: {
            'searcheModel.time_type'(newVal, oldVal) {
                // 当时间类型改变时，如果切换到申请时间，同步转换日期
                if (newVal === '1') {
                    this.searcheModel.conversion_time = this.searcheModel.apply_time;
                }
            },
            'searcheModel.apply_time'(newVal, oldVal) {
                // 当申请时间改变且时间类型为申请时间时，同步转换日期
                if (this.searcheModel.time_type === '1') {
                    this.searcheModel.conversion_time = newVal;
                }
            }
        },
        mounted(){
        },
        created:function(){
            this.submit();
        },
        methods:{
            submit(){
                // 同步转换日期与申请时间
                if (this.searcheModel.time_type === '1') {
                    this.searcheModel.conversion_time = this.searcheModel.apply_time;
                }
                this.bar_chart_key ++;
                this.funnel_chart_key ++;
                this.simple_chart_key ++;
                this.getOriginCountData(this.searcheModel);
                this.getProductCountData(this.searcheModel);
                this.getStatusCountData(this.searcheModel);
                this.getConversionlist(this.searcheModel);
                this.getCycleConversionlist(this.searcheModel); // 新增：获取周期转化数据
            },
            getData(params) {
                ClueService.getAnalyze(params).then(res=>{
                    this.list = [res.data];
                })
            },
            // 新增方法：周期订单弹窗
            tableCycleOrderDialog(row, cycle_type) {
                this.dialog_table_order_key++;
                this.params = _.clone(this.searcheModel);
                this.params['user_id'] = row.user_id;
                this.params['cycle_type'] = cycle_type; // 'trial'/'effective'/'success'

                // 添加转换日期参数
                if (this.searcheModel.conversion_time && this.searcheModel.conversion_time.length > 0) {
                    this.params['conversion_start_time'] = this.searcheModel.conversion_time[0];
                    this.params['conversion_end_time'] = this.searcheModel.conversion_time[1];
                }

                this.dialogTableOrderVisible = true;
            },
            getConversionlist(params){
                // loading 动画
                this.loading = true;
                ClueCount.getList(params, 'conversion-table').then((res) => {
                    if (res.code == 0) {
                        this.traces_list = res.data;
                    }
                    this.loading = false;
                }).catch(err => {
                    console.error(err);
                    this.loading = false;
                });
            },
            // 处理转换日期变更
            handleConversionTimeChange(value) {
                // 日期变更时可以选择自动查询或手动点击查询按钮
                console.log('转换日期已变更:', value);
            },

            // 重置转换日期
            resetConversionTime() {
                this.searcheModel.conversion_time = this.searcheModel.apply_time;
                this.getCycleConversionlist(this.searcheModel);
            },

            // 新增方法：获取周期转化数据
            getCycleConversionlist(params){
                this.cycleLoading = true;

                const requestParams = {
                    ...params,
                    conversion_start_time: params.conversion_time && params.conversion_time.length > 0 ? params.conversion_time[0] : '',
                    conversion_end_time: params.conversion_time && params.conversion_time.length > 0 ? params.conversion_time[1] : '',
                };

                Promise.all([
                    ClueCount.getList(requestParams, 'sales-leads-cycle-customer-and-order'),
                    ClueCount.getList(requestParams, 'sales-leads-cycle-effective-customer-and-order'),
                    ClueCount.getList(requestParams, 'sales-leads-cycle-formal-order-and-customer')
                ]).then(([res1, res2, res3]) => {
                    console.log('接口1返回(试用):', res1);
                    console.log('接口2返回(有效):', res2);
                    console.log('接口3返回(成交):', res3);

                    if (res1.code == 0 && res2.code == 0 && res3.code == 0) {
                        const data1 = res1.data || [];
                        const data2 = res2.data || [];
                        const data3 = res3.data || [];

                        const userMap = new Map();

                        // 处理第一个接口数据（试用）
                        data1.forEach(item => {
                            console.log('处理试用用户:', item.user_name || item.name, {
                                number_of_associated_users: item.number_of_associated_users,
                                number_of_associated_orders: item.number_of_associated_orders
                            });

                            userMap.set(item.user_id, {
                                user_id: item.user_id,
                                user_name: item.user_name || item.name,
                                trial_customer_num: parseInt(item.number_of_associated_users) || 0,
                                trial_order_num: parseInt(item.number_of_associated_orders) || 0,
                                effective_customer_num: 0,
                                effective_order_num: 0,
                                success_customer_num: 0,
                                success_order_num: 0,
                            });
                        });

                        // 🔴 处理第二个接口数据（有效定义）- 修复字段名
                        data2.forEach(item => {
                            console.log('处理有效用户:', item.user_name || item.name, {
                                number_of_effective_customer: item.number_of_effective_customer,
                                number_of_effective_order: item.number_of_effective_order
                            });

                            if (userMap.has(item.user_id)) {
                                const user = userMap.get(item.user_id);
                                user.effective_customer_num = parseInt(item.number_of_effective_customer) || 0;
                                user.effective_order_num = parseInt(item.number_of_effective_order) || 0;
                            } else {
                                userMap.set(item.user_id, {
                                    user_id: item.user_id,
                                    user_name: item.user_name || item.name,
                                    trial_customer_num: 0,
                                    trial_order_num: 0,
                                    effective_customer_num: parseInt(item.number_of_effective_customer) || 0,
                                    effective_order_num: parseInt(item.number_of_effective_order) || 0,
                                    success_customer_num: 0,
                                    success_order_num: 0,
                                });
                            }
                        });

                        // 处理第三个接口数据（成交）
                        data3.forEach(item => {
                            console.log('处理成交用户:', item.user_name || item.name, item);

                            if (userMap.has(item.user_id)) {
                                const user = userMap.get(item.user_id);
                                // 尝试多个可能的字段名
                                user.success_customer_num = parseInt(
                                    item.success_customer_num ||
                                    item.number_of_success_customer ||
                                    item.number_of_formal_customer
                                ) || 0;
                                user.success_order_num = parseInt(
                                    item.success_order_num ||
                                    item.number_of_success_order ||
                                    item.number_of_formal_order
                                ) || 0;
                            } else {
                                userMap.set(item.user_id, {
                                    user_id: item.user_id,
                                    user_name: item.user_name || item.name,
                                    trial_customer_num: 0,
                                    trial_order_num: 0,
                                    effective_customer_num: 0,
                                    effective_order_num: 0,
                                    success_customer_num: parseInt(
                                        item.success_customer_num ||
                                        item.number_of_success_customer ||
                                        item.number_of_formal_customer
                                    ) || 0,
                                    success_order_num: parseInt(
                                        item.success_order_num ||
                                        item.number_of_success_order ||
                                        item.number_of_formal_order
                                    ) || 0,
                                });
                            }
                        });

                        this.cycle_traces_list = Array.from(userMap.values());
                        console.log('最终合并的数据:', this.cycle_traces_list);
                    }
                    this.cycleLoading = false;
                }).catch(err => {
                    console.error('请求失败:', err);
                    this.$message.error('获取周期转化数据失败');
                    this.cycleLoading = false;
                });
            },

            // 新增方法：周期表格合计
            getCycleSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums.push('合计：');
                        return;
                    }
                    let sum = 0;
                    data.forEach(item => {
                        sum += Number(item[column.property]) || 0;
                    });
                    sums.push(sum);
                });
                return sums;
            },

            // 新增方法：周期客户查看
            handleCycleCustomerView(row, type) {
                 this.dialog_cycle_customer_key++;
                   this.cycleCustomerParams = _.clone(this.searcheModel);
                   this.cycleCustomerParams['user_id'] = row.user_id;
                   this.cycleCustomerParams['cycle_type'] = type; // trial/effective/success

                   // 添加转换日期参数
                   if (this.searcheModel.conversion_time && this.searcheModel.conversion_time.length > 0) {
                       this.cycleCustomerParams['conversion_start_time'] = this.searcheModel.conversion_time[0];
                       this.cycleCustomerParams['conversion_end_time'] = this.searcheModel.conversion_time[1];
                   }

                   this.dialogCycleCustomerVisible = true;
            },

            // 新增方法：周期订单查看
            handleCycleOrderView(row, type) {
                var params = _.clone(this.searcheModel);
                params['user_id'] = row.user_id;
                params['cycle_type'] = type; // trial/effective/success

                // 添加转换日期参数
                if (this.searcheModel.conversion_time && this.searcheModel.conversion_time.length > 0) {
                    params['conversion_start_time'] = this.searcheModel.conversion_time[0];
                    params['conversion_end_time'] = this.searcheModel.conversion_time[1];
                }

                let routeData = this.$router.resolve({
                    path: "/order/index",
                    query: params,
                });
                window.open(routeData.href, '_blank');
            },

            getOriginCountData(params) {
                this.total_origin_num = 0;
                ClueService.getOriginCountData(params).then(res=>{
                    this.origin_count_data = res.data;
                    // 遍历二维数组并将字符串类型数字转换为数字类型后累加
                    for (let i = 0; i < this.origin_count_data.length; i++) {
                        let num = parseInt(this.origin_count_data[i].value);
                        if (!isNaN(num)) { // 确保转换成功
                            this.total_origin_num += num;
                        }
                    }
                })
            },

            getProductCountData(params) {
                ClueService.getProductCountData(params).then(res=>{
                    this.product_count_data = res.data;
                })
            },

            getStatusCountData(params) {
                ClueService.getStatusCountData(params).then(res=>{
                    this.status_count_data = res.data;
                })
            },

            //运营渠道 Cascader 级联选择器,切换事件,表单model赋值
            channelHandleChange(value) {
                if(value && value.length > 0){
                    this.searcheModel.source = value[value.length - 1].toString();
                    this.channel = {
                        pid: value.length == 2 ? value[0] : 0,
                        id: value[value.length - 1],
                    };
                }else{
                    this.searcheModel.source = '';
                    this.channel =  _.clone(_.extend(this.searcheModel, {
                        pid: '',
                        id: '',
                    }));
                }
            },
            productChange(value) {
                this.searcheModel.product_id = value;
            },
            changeBranch(value) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.searcheModel.branch_id = value[value.length - 1];
                } else {
                    this.searcheModel.branch_id = "";
                }
            },
            salesmanHandleChange(object) {
                this.searcheModel.user_id = object.label;
            },

            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    // 第一列不计算合计，显示自定义的文字内容
                    if (index === 0) {
                        sums.push('合计：');
                        return;
                    }
                    // 初始化合计值为0
                    let sum = 0;
                    // 遍历数据，累加顶级行的值
                    data.forEach(item => {
                        // 累加当前项的值，注意转换为数字
                        sum += Number(item[column.property]);
                    });
                    // 如果所有值都是数字，则显示合计结果，否则显示'-'
                    if (!isNaN(sum)) {
                        sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                    } else {
                        sums.push('--');
                    }
                });
                return sums;
            },

            handleView(val, is_bind_customer) {
                var params = _.clone(this.searcheModel);
                params['is_bind_customer'] = is_bind_customer;
                if(val.hasOwnProperty('user_id')){
                    params['user_id'] = val.user_id;
                }
                let routeData = this.$router.resolve({
                    path: "/sales-leads/index",
                    query: params,
                });
                window.open(routeData.href, '_blank');
            },

            tableCustomerDialog(row){
                this.dialog_table_customer_key ++;
                this.params = _.clone(this.searcheModel);
                this.params['user_id'] = row.user_id;
                this.dialogTableCustomerVisible = true;
            },

            tableOrderDialog(row, order_type){
                this.dialog_table_order_key ++;
                this.params = _.clone(this.searcheModel);
                this.params['user_id'] = row.user_id;
                this.params['order_type'] = order_type;
                this.dialogTableOrderVisible = true;
            },
            // 新增方法：周期订单弹窗
            tableCycleOrderDialog(row, cycle_type) {
                this.dialog_cycle_order_key++;
                this.cycleParams = _.clone(this.searcheModel);
                this.cycleParams['user_id'] = row.user_id;
                this.cycleParams['cycle_type'] = cycle_type; // 'trial'/'effective'/'success'

                // 设置标题
                if (cycle_type === 'trial') {
                    this.cycleDialogTitle = '关联试用订单数';
                } else if (cycle_type === 'effective') {
                    this.cycleDialogTitle = '有效试用订单数';
                } else if (cycle_type === 'success') {
                    this.cycleDialogTitle = '关联订单成交数';
                } else {
                    this.cycleDialogTitle = '周期订单列表';
                }

                // 添加转换日期参数
                if (this.searcheModel.conversion_time && this.searcheModel.conversion_time.length > 0) {
                    this.cycleParams['conversion_start_time'] = this.searcheModel.conversion_time[0];
                    this.cycleParams['conversion_end_time'] = this.searcheModel.conversion_time[1];
                }

                this.dialogCycleOrderVisible = true;
            },
        }
    }
</script>

<style scoped>
    #h5 {
        width: 1000px;
        height: 400px;
    }
    #web {
        width: 1200px;
        height: 300px;
    }
    /* 转换日期筛选区域样式 */
    .item-title {
        font-weight: bold;
        font-size: 16px;
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/views/count/clue/analyze.vue